// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"f1ce5cdc","213":"d545d048","239":"b67fbdf4","732":"5420f41a","762":"12f110b7"}[chunkId] + ".chunk.js";
};